// Initialize theme on page load (runs immediately, before Turbo)
if (localStorage.theme === "dark") {
  document.documentElement.classList.add("dark");
} else {
  document.documentElement.classList.remove("dark");
}

// Toggle theme functionality
document.addEventListener('turbo:load', function () {
  const switchTheme = document.getElementById("switchTheme");
  if (switchTheme) {
    switchTheme.addEventListener("click", function (e) {
      e.preventDefault();
      const htmlClasses = document.documentElement.classList;
      
      if (htmlClasses.contains("dark")) {
        htmlClasses.remove("dark");
        localStorage.setItem("theme", "light");
      } else {
        htmlClasses.add("dark");
        localStorage.setItem("theme", "dark");
      }
    });
  }
});